export default __webpack_public_path__ + "static/media/strike_through_icon_grey.b80a91cc.svg";